// extracted by mini-css-extract-plugin
module.exports = {"aiFeaturesContainer":"style-module__aiFeaturesContainer___1oAz2"};